module.exports = __webpack_public_path__ + "img/main-icn-01.2cc42c13.svg";